import { render, staticRenderFns } from "./menus-manager.vue?vue&type=template&id=51d6e47d&scoped=true&"
import script from "./menus-manager.vue?vue&type=script&lang=js&"
export * from "./menus-manager.vue?vue&type=script&lang=js&"
import style0 from "./menus-manager.vue?vue&type=style&index=0&id=51d6e47d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6e47d",
  null
  
)

export default component.exports